// extracted by mini-css-extract-plugin
export var wrapper = "height-space-module--wrapper--c0038";